export default __webpack_public_path__ + "static/media/brandstof_diesel.8ab7d803.svg";